// extracted by mini-css-extract-plugin
export default {"menuWrapper":"ProjectMenu_menuWrapper__HlAKj","menuButton":"ProjectMenu_menuButton__XrBqT","dropdown":"ProjectMenu_dropdown__9bDvc","item":"ProjectMenu_item__ksMTt"};